import PropTypes from 'prop-types'
import React from 'react'
import Link from 'components/Link'
import ListRow from 'components/ListRow'
import { fromNowDatetimeUtil } from 'utils/datetime'
import { View } from 'components/View'

class NotificationText extends React.Component {
  static defaultProps = {
    prefix: null,
    value: null,
    bold: null
  }

  static propTypes = {
    bold: PropTypes.string,
    prefix: PropTypes.string,
    value: PropTypes.string,
    url: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired
  }

  handleClick () {
  }

  renderBold () {
    if (!this.props.bold) {
      return
    }
    if (this.props.prefix) {
      return <strong> {this.props.bold}</strong>
    }
    return <strong>{this.props.bold}</strong>
  }

  renderPrefix () {
    if (!this.props.prefix) {
      return
    }
    return <span>{this.props.prefix}</span>
  }

  renderValue () {
    if (!this.props.value) {
      return
    }
    if (this.props.bold) {
      return <span> {this.props.value}</span>
    }
    return <span>{this.props.value}</span>
  }

  render () {
    return (
      <View style={{ flexGrow: '1' }}>
        <Link
          onClick={this.handleClick.bind(this)}
          to={this.props.url}
        >
          <div className='notification-text'>
            <ListRow.Text>
              {this.renderPrefix()}
              {this.renderBold()}
              {this.renderValue()}
            </ListRow.Text>
          </div>
          <ListRow.Meta>
            {fromNowDatetimeUtil(new Date(this.props.updatedAt))}
          </ListRow.Meta>
        </Link>
      </View>
    )
  }
}

export default NotificationText
